const getNumber = (data) => data?.replace(/\D/g, '')

export function validatePhone(phone) {
  return /^(\d{2})(\d{8,9})$/.test(getNumber(phone))
}

export function validateCep(cep) {
  return /^\d{5}-?\d{3}$/.test(getNumber(cep))
}
